import dayjs from 'dayjs';

export const DUE_PAYMENT_YM = /^(\d{4})\/(\d{2})$/;

/**
 * Calendar (wall) year/month for 課金開始: API string YYYY/MM or Date from month picker (local 1st).
 */
export function billingCalendarMonth(
  due: unknown,
): { y: number; m0: number } | undefined {
  if (due == null || due === '') return undefined;
  if (typeof due === 'string') {
    const m = DUE_PAYMENT_YM.exec(String(due).trim());
    if (!m) return undefined;
    return { y: Number(m[1]), m0: Number(m[2]) - 1 };
  }
  const d = due instanceof Date ? due : new Date(due as string);
  if (!dayjs(d).isValid()) return undefined;
  return { y: d.getFullYear(), m0: d.getMonth() };
}

/** Start of the 1st day of the billing month (local), for Yup comparisons. */
export function billingMonthFirstDayStart(due: unknown): dayjs.Dayjs | null {
  const p = billingCalendarMonth(due);
  if (!p) return null;
  return dayjs(new Date(p.y, p.m0, 1)).startOf('day');
}

/**
 * Inclusive max for 講座提供利用開始 (PrimeReact compares date parts; end-of-day avoids edge cases).
 */
export function trialEndMaxDateForDuePayment(due: unknown): Date | undefined {
  const p = billingCalendarMonth(due);
  if (!p) return undefined;
  return new Date(p.y, p.m0, 1, 23, 59, 59, 999);
}

export function duePaymentDateFromApi(
  raw: string | null | undefined,
): Date | undefined {
  if (raw == null || raw === '') return undefined;
  const m = DUE_PAYMENT_YM.exec(String(raw).trim());
  if (m) {
    return new Date(Number(m[1]), Number(m[2]) - 1, 1);
  }
  const d = new Date(raw);
  return dayjs(d).isValid() ? d : undefined;
}
